$ ->
  $('.searches.show input[name="download_spreadsheet"]').click ->
    setTimeout(enable_submit_buttons,200)

enable_submit_buttons = ->
  $('.searches.show input[type="submit"]').attr('disabled',false)